import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=a1d18eca"
import script from "./Contacts.vue?vue&type=script&lang=ts"
export * from "./Contacts.vue?vue&type=script&lang=ts"
import style0 from "./Contacts.vue?vue&type=style&index=0&id=a1d18eca&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports